// bullet ("- ", "* ", "+ ") or numbered ("1. ") list item marker, optionally indented for nested lists
const listItemMarker = String.raw`[ \t]*(?:[-*+]|\d+[.)])[ \t]`;

// a single '\n' that is not part of a paragraph break ('\n\n'), is not at the end of the chunk and is
// not followed by another list item, where it separates two blocks instead of being a soft break
const softLineBreak = new RegExp(String.raw`(?<!\n)\n(?=[^\n])(?!${listItemMarker})`, 'g');

/**
 * Rewrites CRLF and lone CR line endings to LF. Stored content can come from other systems that use
 * windows line endings, and every markdown regex here as well as the lexical importer only handle LF:
 * a CR would end up as an invisible character inside the text and break the hard line break markers.
 */
export const normalizeLineEndings = (markdown: string): string => markdown.replace(/\r\n?/g, '\n');

/**
 * Post-processes markdown produced by `$convertToMarkdownString()` so that every "soft" line break
 * (a single `\n` inside a paragraph, e.g. produced by Shift+Enter in the editor) is rewritten as a CommonMark hard line break (two trailing spaces + `\n`).
 */
export const fixLineBreaks = (markdown: string): string => {
  return (
    normalizeLineEndings(markdown)
      // Split on code blocks so we don't touch their content
      .split(/(```[\s\S]*?```)/g)
      .map((chunk, i) => {
        const isCodeFence = i % 2 === 1;
        if (isCodeFence) {
          return chunk;
        }

        return (
          chunk
            // strip any pre-existing trailing whitespace on each line first, so we don't end up with 4+ spaces
            .replace(/[ \t]+\n/g, '\n')
            // normalize any existing backslash-style hard breaks too
            .replace(/\\\n/g, '\n')
            // add "  \n" to every remaining soft line break
            .replace(softLineBreak, '  \n')
        );
      })
      .join('')
  );
};
